import React from 'react';
import classnames from 'classnames';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import s from './FlagSwitcher.scss';
export class FlagSwitcher extends React.Component {
    componentDidMount() {
        window.addEventListener('keydown', this.onKeyDown);
    }
    componentWillUnmount() {
        window.removeEventListener('keydown', this.onKeyDown);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.show !== this.props.show) {
            this.setState({
                isVisible: !!this.props.show
            });
        }
    }
    render() {
        const { isVisible  } = this.state;
        if (!isVisible) {
            return null;
        }
        const { flags  } = this.props;
        return /*#__PURE__*/ React.createElement("div", {
            className: classnames(s['root'], this.props.show && s['showing'])
        }, /*#__PURE__*/ React.createElement("div", {
            className: s['hide'],
            onClick: this.onHide
        }, "x"), /*#__PURE__*/ React.createElement("div", {
            className: s['header']
        }, "Flags"), /*#__PURE__*/ React.createElement("ul", {
            className: s['list']
        }, flags.map((flag)=>/*#__PURE__*/ React.createElement("li", {
                className: s['list-item'],
                key: flag
            }, /*#__PURE__*/ React.createElement("span", null, flag), /*#__PURE__*/ React.createElement("button", {
                className: s['remove'],
                onClick: ()=>this.onRemove(flag)
            }, "x"))), /*#__PURE__*/ React.createElement("li", {
            className: s['list-item']
        }, /*#__PURE__*/ React.createElement(TextInput, {
            id: "flag-switcher-input",
            className: s['input'],
            ref: (node)=>{
                this.inputNode = node;
            },
            onKeyUp: (ev)=>ev.key === 'Enter' && this.onAddNew(),
            label: 'Flag',
            value: '',
            isLabelHidden: true,
            autoFocus: true
        }), /*#__PURE__*/ React.createElement("button", {
            className: s['add'],
            onClick: this.onAddNew
        }, "Add new"))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isVisible: this.props.show || false
        };
        this.onAddNew = ()=>{
            const { setFlags  } = this.props;
            const val = this.inputNode && this.inputNode.value;
            if (!val) {
                return;
            }
            setFlags({
                [val]: true
            });
        };
        this.onRemove = (key)=>{
            const { setFlags  } = this.props;
            setFlags({
                [key]: false
            });
        };
        this.onKeyDown = (event)=>{
            const { flags  } = this.props;
            if (event.repeat) {
                return;
            }
            if (event.altKey && event.ctrlKey && (event.key === 'F2' || event.key === '`')) {
                this.setState({
                    isVisible: true
                });
                if (flags.includes('bi_xray')) {
                    const links = document.querySelectorAll('button,a');
                    for(let i = 0; i < links.length; i++){
                        const el = links[i];
                        if (!el.hasAttribute('data-bidata')) {
                            el.style.backgroundColor = 'rgba(255,0,0,.5)';
                        } else {
                            // will improve this later to use proper tooltip
                            el.setAttribute('title', el.dataset.bidata || '');
                            el.style.backgroundColor = 'rgba(0,255,0,.5)';
                        }
                    }
                }
            }
        };
        this.onHide = ()=>{
            this.setState({
                isVisible: false
            });
            this.props.onHide && this.props.onHide();
        };
    }
}
export default FlagSwitcher;
